import { CreateUserFeedbackDTO } from "@onetutor/shared/dto";
import { onetutorApi } from "./onetutorApi.ts";

const feedbackApi = onetutorApi.injectEndpoints({
  endpoints: (builder) => ({
    createUserFeedback: builder.mutation<
      CreateUserFeedbackDTO,
      CreateUserFeedbackDTO
    >({
      query: (feedback) => ({
        url: "feedback",
        method: "POST",
        body: feedback,
      }),
    }),
  }),
});

export const { useCreateUserFeedbackMutation } = feedbackApi;
